import React, {useEffect} from "react";
import '../App.css';
import '../nav/Nav-Header'
import AlertsBox from "../cards/Recent-Alerts";

import 'bulma/css/bulma.min.css';
import {Container, Columns, Notification, Button} from 'react-bulma-components';
import Header from "../nav/Nav-Header";
import { Link } from "react-router-dom";
import {doc, getDoc} from "firebase/firestore";
import {db} from "../firestore";


function Home() {

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    let username = readCookie("Username")
    console.log(username)

    if (username !== null) {
        console.log("User is Logged in.")
    }

    useEffect(() => {

        const getAlerts = async () => {

            const hospitalbox = document.getElementById("medical");
            const firebox = document.getElementById("fire");
            const policebox = document.getElementById("police");
            const sensorbox = document.getElementById("sensor_home");
            const sensorbox_2 = document.getElementById("sensor_car");
            const sensorbox_3 = document.getElementById("sensor_health");


            if (readCookie("Username") !== null) {

                const docRef = doc(db, "Users", username);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    console.log("Document data:", docSnap.data());
                    let TypeofUser = docSnap.data()["TypeofUser"]
                    console.log("Home js, usertype", TypeofUser)

                    if (TypeofUser === "NormalUser") {
                        hospitalbox.style.display = "None"
                        firebox.style.display = "None"
                        policebox.style.display = "None"
                    } else {
                        console.log("Hiding sensor box")
                        sensorbox.style.display = "None"
                        sensorbox_2.style.display = "None"
                        sensorbox_3.style.display = "None"

                    }

                    return TypeofUser


                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                    return null
                }
            }
        }

        getAlerts().then(r => {
            console.log(r)
        })

    }, []);



    return (
        <div className="App">
            <Header/>

            <Container style={{
                top: '8vh'
            }}>
                <Columns >
                    <Columns.Column>
                        <AlertsBox />
                    </Columns.Column>
                </Columns>
                <br/>
                <Columns centered>
                    <Columns.Column>
                        <div id="medical" className={"smallCardLayoutStyle has-text-centered"} style={{height: "100px"}}>
                            <Columns>
                                <Columns.Column>
                                    <Link to="/hospital">
                                    <Button className={"is-rounded"} color="success" size="Large" style={{padding: "25px", width: "80%"}} href="/hospital">
                                        <span><b>Medical Portal</b></span><br/>
                                    </Button>
                                    </Link>
                                </Columns.Column>
                            </Columns>
                        </div>
                    </Columns.Column>
                    <Columns.Column>
                        <div id="fire" className={"smallCardLayoutStyle has-text-centered"} style={{height: "0"}}>
                            <Columns>
                                <Columns.Column>
                                    <Link to="/fire">
                                    <Button className={"is-rounded"} color="info" size="Large" style={{padding: "25px", width: "80%", backgroundColor: "Orange"}}>
                                        <span><b>Fire Services Portal</b></span><br/>
                                    </Button>
                                    </Link>
                                </Columns.Column>
                            </Columns>
                        </div>
                    </Columns.Column>
                    <Columns.Column>
                        <div id="police" className={"smallCardLayoutStyle has-text-centered"} style={{height: "0"}}>
                            <Columns>
                                <Columns.Column>
                                    <Link to="/police">
                                        <Button className={"is-rounded"} color="info" size="Large" style={{padding: "25px", width: "80%", backgroundColor: "Navy"}}>
                                            <span><b>Police Services Portal</b></span><br/>
                                        </Button>
                                    </Link>
                                </Columns.Column>
                            </Columns>
                        </div>
                    </Columns.Column>
                </Columns>
                <Columns centered>
                    <Columns.Column>
                        <div id="sensor_home" className={"smallCardLayoutStyle has-text-centered"} style={{height: "0"}}>
                            <Columns>
                                <Columns.Column>
                                    <Link to="/sensor">
                                        <Button className={"is-outlined is-rounded"} color="info" size="Large" style={{padding: "25px", width: "80%"}}>
                                            <span><b>View Sensor at Home</b></span><br/>
                                        </Button>
                                    </Link>
                                </Columns.Column>
                            </Columns>
                        </div>
                    </Columns.Column>
                    <Columns.Column>
                        <div id="sensor_car" className={"smallCardLayoutStyle has-text-centered"} style={{height: "10px"}}>
                            <Columns>
                                <Columns.Column>
                                    <Link to="/sensor">
                                        <Button className={"is-outlined is-rounded"} color="info" size="Large" style={{padding: "25px", width: "80%"}}>
                                            <span><b>View Vehicle Sensor</b></span><br/>
                                        </Button>
                                    </Link>
                                </Columns.Column>
                            </Columns>
                        </div>
                    </Columns.Column>
                    <Columns.Column>
                        <div id="sensor_health" className={"smallCardLayoutStyle has-text-centered"} style={{height: "100px"}}>
                            <Columns>
                                <Columns.Column>
                                    <Link to="/sensor">
                                        <Button className={"is-outlined is-rounded"} color="info" size="Large" style={{padding: "25px", width: "80%"}}>
                                            <span><b>View Emergency Health Sensor</b></span><br/>
                                        </Button>
                                    </Link>
                                </Columns.Column>
                            </Columns>
                        </div>
                    </Columns.Column>
                </Columns>
            </Container>
        </div>
    );
}


export default Home;
